import { Customer } from "@/types/v2";

/**
 * Formats a customer's name by combining their first and last name or their contact's first
 * and last name if available. If neither is provided, returns a default value.
 * @param {Customer | Record<string, never> | undefined} customer - The customer object containing first and last name or contact information.
 * @returns {string} A formatted full name of the customer, contact name, or "Unknown Customer" if no information is available.
 */
export function formatCustomerName(
  customer: Customer | Record<string, never> | undefined
) {
  if (!customer) return "Unknown Customer";
  if (!customer.firstName && !customer.lastName) {
    if (customer.contactFirstName && customer.contactLastName) {
      return `${customer.contactFirstName} ${customer.contactLastName}`;
    } else if (customer.contactFirstName) {
      return customer.contactFirstName;
    } else if (customer.contactLastName) {
      return customer.contactLastName;
    } else {
      return "Unknown Customer";
    }
  }
  if (!customer.firstName) return customer.lastName;
  if (!customer.lastName) return customer.firstName;
  return `${customer.firstName} ${customer.lastName}`;
}
